// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"411":"83e41dca","6977":"bbbec0f8"}[chunkId] + ".chunk.css";
};